import React, { useState } from 'react';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AppsService from '../../../services/apps_service'

function AddSourceButton({ isAppAdded, appId, sourceType, country, onAppAdded, onAppDeclined }) {
    const [isAdded, setIsAdded] = useState(isAppAdded);
    const [isLoading, setIsLoading] = useState(false);

    const handleAddApp = () => {
        setIsLoading(true);
        if (isAdded) {
            AppsService.removeSource(appId)
                .then(response => {
                    setIsLoading(false);
                    setIsAdded(false);
                })
                .catch(error => {
                    setIsLoading(false);
                    onAppDeclined(error.message);
                })
        } else {
            AppsService.addSource(appId, sourceType, country)
                .then(response => {
                    setIsLoading(false);
                    if (response.status === 200 & !('error' in response.data)) {
                        setIsAdded(true);
                        onAppAdded();
                    } else {
                        onAppDeclined(response.data['error'])
                    }
                })
                .catch(error => {
                    setIsLoading(false);
                    onAppDeclined(error.message)
                });
        }
    };

    return (
        <LoadingButton
            color={isAdded ? 'error' : 'primary'}
            onClick={handleAddApp}
            variant='outlined'
            disabled={isLoading}
        >
            {isLoading ? (isAdded ? 'Removing...' : 'Adding...') : (isAdded ? 'Remove' : 'Add')}
        </LoadingButton>
    );
}

export default AddSourceButton;
